import {
  IEntertainmentEvent,
  IEntertainmentIndividualPerformance,
  IEntertainmentPerformance,
  IEntertainmentVenue,
} from '@shared/shared/interfaces/entertainment-event.interfaces';
import * as entertainmentEventPerformancesActions from '../actions/entertainment-event-performances.actions';

export interface SelectedPerformance extends IEntertainmentIndividualPerformance {
  loaded: boolean;
  loading: boolean;
}
export interface PerformancesList {
  performances: Array<IEntertainmentPerformance>;
  loaded: boolean;
  loading: boolean;
}
export interface EntertainmentEventPerformancesState {
  selected_performance: SelectedPerformance;
  performances_list: PerformancesList;
}

export const initialState: EntertainmentEventPerformancesState = {
  selected_performance: {
    currency: '',
    end_date: '',
    end_local_datetime: '',
    estimated_price_max: '',
    estimated_price_max_currency: '',
    estimated_price_min: '',
    estimated_price_min_currency: '',
    event: {} as IEntertainmentEvent,
    has_vip_suites: false,
    id: 0,
    is_hot_ticket: false,
    start_date: '',
    start_local_datetime: '',
    status: '',
    status_localised: '',
    full_address: '',
    ticket_types: [],
    url: '',
    venue: {} as IEntertainmentVenue,
    loaded: false,
    loading: false,
  },
  performances_list: {
    loaded: false,
    loading: false,
    performances: [],
  },
};

export function reducer(
  state = initialState,
  action: entertainmentEventPerformancesActions.EntertainmentEventPerformancesAction
): EntertainmentEventPerformancesState {
  switch (action.type) {
    /**
     * Index all performances
     */
    case entertainmentEventPerformancesActions.GET_ALL_PERFORMANCES: {
      return {
        ...state,
        performances_list: {
          ...state.performances_list,
          loading: true,
        },
      };
    }

    case entertainmentEventPerformancesActions.GET_ALL_PERFORMANCES_SUCCESS: {
      return {
        ...state,
        performances_list: {
          performances: action.payload,
          loaded: true,
          loading: false,
        },
      };
    }

    case entertainmentEventPerformancesActions.GET_ALL_PERFORMANCES_FAIL: {
      return {
        ...state,
        performances_list: {
          ...state.performances_list,
          loading: false,
          loaded: false,
        },
      };
    }

    /**
     * get individual performance
     */
    case entertainmentEventPerformancesActions.GET_INDIVIDUAL_PERFORMANCE: {
      return {
        ...state,
        selected_performance: {
          ...state.selected_performance,
          loading: true,
        },
      };
    }

    case entertainmentEventPerformancesActions.GET_INDIVIDUAL_PERFORMANCE_SUCCESS: {
      return {
        ...state,
        selected_performance: {
          ...action.payload,
          loaded: true,
          loading: false,
        },
      };
    }

    case entertainmentEventPerformancesActions.GET_INDIVIDUAL_PERFORMANCE_FAIL: {
      return {
        ...state,
        selected_performance: {
          ...state.selected_performance,
          loaded: false,
          loading: false,
        },
      };
    }

    /**
     * Reset performances
     */
    case entertainmentEventPerformancesActions.RESET_ALL_PERFORMANCES: {
      return {
        ...state,
        performances_list: {
          ...initialState.performances_list,
        },
      };
    }

    case entertainmentEventPerformancesActions.RESET_INDIVIDUAL_PERFORMANCE: {
      return {
        ...state,
        selected_performance: {
          ...initialState.selected_performance,
        },
      };
    }
    default:
      return state;
  }
}

export const getPerformancesList = (state: EntertainmentEventPerformancesState) => state.performances_list;
export const getSelectedPerformance = (state: EntertainmentEventPerformancesState) => state.selected_performance;
